<template>
  <b-col cols="12" class="padding-0 margin-bottom-16">
    <div class="font-size-14 color-complementary-400 margin-bottom-8">
      {{ label }}
    </div>
    <div
      v-for="(item, index) in items"
      :key="`a-${index}`"
      class="font-size-12 color-complementary-300 margin-bottom-8"
    >
      {{ `${item.label}: ${item.value}` }}
    </div>
  </b-col>
</template>

<script>
import { toRefs } from 'vue';
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    // generate props data
    const { label, items } = toRefs(props);

    // return data to be used in template
    return { label, items };
  },
};
</script>
